export const AeoMark = ({ className = "w-8 h-8" }) => (
  <span className={`${className} rounded-xl gos-gradient flex items-center justify-center shrink-0`}>
    <svg viewBox="0 0 24 24" className="w-1/2 h-1/2" fill="none">
      <path d="M12 3.5 L21 20 H3 Z" fill="#fff" fillOpacity="0.95" />
      <path d="M12 10 L16.5 20 H7.5 Z" fill="#1E5AD6" />
    </svg>
  </span>
);

export const Logo = ({ size = "md" }) => {
  const markSize = size === "lg" ? "w-10 h-10" : "w-8 h-8";
  const wordSize = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex items-center gap-2.5">
      <AeoMark className={markSize} />
      <div className="leading-none">
        <div className={`font-display ${wordSize} font-semibold text-white tracking-tight`}>AEO</div>
        <div className="text-[8px] uppercase tracking-[0.15em] text-slate-400 mt-0.5">by Smart Marketer</div>
      </div>
    </div>
  );
};
